import Accordion from '@ui/accordion'
import { StyledText } from './style'
import BoxImage from '@components/box-image/layout-10'
import { faFilePdf } from '@fortawesome/pro-regular-svg-icons/faFilePdf'

const DocumentArchive = ({ dataCurrent, dataArchive }) => {
  return (
    <>
      {dataCurrent?.items?.map((item) => (
        <BoxImage
          key={item.id}
          showTitle
          title={item.title}
          desc={item.description}
          designation={item.designation}
          image={item.images[0]}
          icon={faFilePdf}
          path={item.pdfs[0]?.src.localFile.publicURL || item.path}
        />
      ))}
      <div style={{ height: '30px' }} />
      {dataArchive?.items?.length > 0 && (
        <StyledText>
          <Accordion data={dataArchive.items} disableDefaultActive />
        </StyledText>
      )}
    </>
  )
}

export default DocumentArchive
